import React from 'react'
import * as yup from 'yup'
import { ERROR_TEMPLATES, regexEmail } from '@src/utils/validators'

import ModalRoot from '@ui/components/ModalRoot'
import { InputBlurWithCTA_RHF } from '@ui/components/InputBlurRHF'
import chiudi from '@assets/Ico_chiudi_verde.png'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { _useSalvaBozza } from './pages/use-salvaBozza'
import { useAppContext } from '@hooks/use-app-context'

//const [isModalOpen, setIsModalOpen] = React.useState(false)

//modal
//  const closeModal = () => setIsModalOpen(false)
// const openModal = () => setIsModalOpen(true)

//const [, setShowModal] = React.useState(false)

type ModalProps = {
	isOpen: boolean
	onCloseModal: () => void
}

export const ExitModalForm = ({ isOpen, onCloseModal }: ModalProps) => {
	const exitUrl = import.meta.env.VITE_EXIT_URL
	const { state } = useAppContext()
	const { data: savedData, postData, loadingData } = _useSalvaBozza()

	const anagrafica = yup.object({
		email: yup
			.string()
			.optional()
			.test('regex-email', ERROR_TEMPLATES.invalidEmail, (value) => {
				if (!value) return true
				return regexEmail.test(value)
			})
			.default(''),
	})

	const form = useForm({
		mode: 'onBlur',
		reValidateMode: 'onBlur',
		resolver: yupResolver(anagrafica),
	})

	const {
		control,
		watch,
		//formState: { errors, isValid },
		reset,
		handleSubmit,
		trigger,
		setValue,
		clearErrors,
	} = form

	const emailValue = watch('email') ?? ''

	const isEmailInvalid =
		emailValue.trim() !== '' && !regexEmail.test(emailValue)

	const onCallBack = handleSubmit((formValues) => {
		postData({ body: { ...state.data, EmailSalvaOfferta: formValues.email } })
	})

	React.useEffect(() => {
		if (!savedData) return
		reset({ email: '' })
		onCloseModal()
		window.location.href = exitUrl
	}, [savedData, exitUrl, onCloseModal, reset])

	const onExit = () => {
		// clear the form state to an explicit empty email so reopening shows empty input
		reset({ email: '' })
		onCloseModal()
		window.location.href = exitUrl
	}

	// Also reset when the modal is programmatically closed
	React.useEffect(() => {
		if (!isOpen) reset({ email: '' })
	}, [isOpen, reset])


	//console.log('VALID FORM', isValid)
	return (
		<div>
			<ModalRoot
				isOpen={isOpen}
				onCloseModal={onCloseModal}
				title={'Sei sicuro di voler uscire?'}
				onCallBack={!emailValue?.trim() ? onExit : onCallBack}
				labelOk={'No, continua la richiesta'}
				labelClose={'Si, esci e torna all’homepage'}
				disableButton={false}
				disableButtonAdd={isEmailInvalid || loadingData}
				reverseButton={true}
				loading={loadingData}
			height="h-[570px] md:h-[480px] lg:h-[450px]"
			width="max-w-[370px] md:max-w-[720px] lg:max-w-[980px]"
			>
				{/* Questo contenuto viene passato come 'children' */}
				<div className='font-medium text-[18px] pb-2.5'>
					Ti manca pochissimo per completare la tua richiesta.
				</div>
				<div className='font-[400px] text-[16px]'>
					Se vuoi, puoi inserire la tua email per riprendere più tardi: ti
					invieremo un link per continuare da dove hai lasciato.
					{/* <span className='hidden md:inline'>
						<br></br>
						Approfondisci le modalità di trattamento dei dati da parte di BCC
						CreditoConsumo leggendo l'informativa privacy completa scaricabile
						nella sezione Privacy del sito Crediper.it
					</span> */}
				</div>

				{/* <div className='pt-2 pb-6 px-1'> */}
					<InputBlurWithCTA_RHF
						name='email'
						label='Email'
						type="email"
						control={control}
						validateOnlyOnBlur
						normalizeOnBlur={(value) => value.trim().replace(/\s+/g, '')}
						trigger={trigger}
						setValue={setValue}
						clearErrors={clearErrors}
						renderCTA={({ clear }) => (
							<button type='button' className='cta-base' onClick={clear}>
								<img src={chiudi} className='w-3.5 h-3.5' />
							</button>
						)}
					/>
				{/* </div> */}
			</ModalRoot>
		</div>
	)
}
